import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@/contexts/AuthContext';
import { fetchGroupSettlements, createSettlement } from '@/api/settlements';
import type { CreateSettlementData } from '@sharecost/shared';
import { Analytics } from '@/services/analytics.service';

export function useGroupSettlements(groupId: string | undefined) {
  return useQuery({
    queryKey: ['settlements', groupId],
    queryFn: () => fetchGroupSettlements(groupId!),
    enabled: !!groupId,
  });
}

export function useCreateSettlement() {
  const queryClient = useQueryClient();
  const { user } = useAuth();

  return useMutation({
    mutationFn: (data: CreateSettlementData) => createSettlement(data, user!.id),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['settlements', variables.groupId] });
      queryClient.invalidateQueries({ queryKey: ['balances', variables.groupId] });
      Analytics.track({
        name: 'Settlement Initiated',
        properties: {
          group_id: variables.groupId,
          amount: variables.amount,
          currency: variables.currency,
          from_user_id: variables.fromUserId,
          to_user_id: variables.toUserId,
        },
      });
    },
  });
}
